// extracted by mini-css-extract-plugin
export default {"postcodeHasError":"Postcode_postcodeHasError__JyN6n"};